import App from "App";
import ProtectedRoute from "components/ProtectedRoute";
import PageAgendaDetail from "features/agenda/pages/PageAgendaDetail";
import PageAgendaList from "features/agenda/pages/PageAgendaList";
import PageCreateAgenda from "features/agenda/pages/PageCreateAgenda";
import PageCreateAgendaCheckData from "features/agenda/pages/PageCreateAgendaCheckData";
import PageCreateAgendaTopics from "features/agenda/pages/PageCreateAgendaTopics";
import PageCreateNote from "features/agenda/pages/PageCreateNote";
import PageCreateNoteTopics from "features/agenda/pages/PageCreateNoteTopics";
import PageEditAgendaIdentify from "features/agenda/pages/PageEditAgendaIdentify";
import PageEditNote from "features/agenda/pages/PageEditNote";
import PageNotes from "features/agenda/pages/PageNotes/PageNotes";
import PageAnalytics from "features/analytics/pages/PageAnalytics";
import PageLogin from "features/auth/pages/PageLogin";
import PageRedirect from "features/auth/pages/PageRedirect";
import PageCompanies from "features/companies/pages/PageCompanies";
import PageCompanyMembers from "features/companies/pages/PageCompanyMembers";
import PageCreateCompany from "features/companies/pages/PageCreateCompany";
import PageEditCompany from "features/companies/pages/PageEditCompany";
import PageEditCompanyRecipient from "features/companies/pages/PageEditCompanyRecipient";
import PageContentGroups from "features/content-groups/pages/PageContentGroups";
import PageCreateContentGroup from "features/content-groups/pages/PageCreateContentGroup";
import PageEditContentGroup from "features/content-groups/pages/PageEditContentGroup";
import PageCreateEmail from "features/emails/pages/PageCreateEmail";
import PageEditEmail from "features/emails/pages/PageEditEmail";
import PageEmails from "features/emails/pages/PageEmails";
import PageReportDetail from "features/emails/pages/PageReportDetail";
import PageSelectContent from "features/emails/pages/PageSelectContent";
import PageCreateList from "features/lists/pages/PageCreateList";
import PageEditList from "features/lists/pages/PageEditList";
import PageLists from "features/lists/pages/PageLists";
import ViewLog from "features/logs/components/ViewLog";
import PageMediaLibrary from "features/media-library/pages/pageMediaLibrary";
import PageNewsletterDetail from "features/newsletters/pages/PageNewsletterDetail";
import PageNewsletterReview from "features/newsletters/pages/PageNewsletterReview";
import PageNewsletters from "features/newsletters/pages/PageNewsletters";
import PageNewslettersForReview from "features/newsletters/pages/PageNewslettersForReview";
import PageCreatePerson from "features/people/pages/PageCreatePerson";
import PageEditPerson from "features/people/pages/PageEditPerson";
import PagePeople from "features/people/pages/PagePeople";
import PageCreatePL from "features/pls/pages/PageCreatePL";
import PageEditPL from "features/pls/pages/PageEditPL";
import PagePLs from "features/pls/pages/PagePLs";
import PageReports from "features/reports/pages/PageReports";
import PageCreateTag from "features/tags/pages/PageCreateTag";
import PageEditTag from "features/tags/pages/PageEditTag";
import PageTags from "features/tags/pages/PageTags";
import PageCreateTheme from "features/themes/pages/PageCreateTheme";
import PageEditTheme from "features/themes/pages/PageEditTheme";
import PageThemes from "features/themes/pages/PageThemes";
import PageCreateUser from "features/users/pages/PageCreateUser";
import PageEditUser from "features/users/pages/PageEditUser";
import PageUsers from "features/users/pages/PageUsers";
import LayoutMain from "layouts/LayoutMain";
import { isUserAuthenticated } from "lib/msal";
import { createBrowserRouter, redirect } from "react-router-dom";

const redirectAuthenticatedUser = async () => {
  if (await isUserAuthenticated()) {
    return redirect('/');
  }

  return null;
};

const redirectNotAuthenticatedUser = async () => {
  if (!(await isUserAuthenticated())) {
    return redirect('/login');
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: "/login",
    element: <PageLogin />,
    loader: redirectAuthenticatedUser,
  },
  {
    path: "/",
    element: <App />,
    loader: redirectNotAuthenticatedUser,
    shouldRevalidate: () => false,
    children: [
      {
        path: "/",
        element: <PageRedirect />,
      },

      {
        path: "/clientes/novo",
        element: <PageCreateCompany />,
      },
      {
        path: "/listas-de-disparo/nova",
        element: <PageCreateList />,
      },
      {
        path: "/listas-de-disparo/:id",
        element: <PageEditList />,
      },
      {
        path: "/disparos-de-report/novo/:id/conteudo/:content_id?",
        element: <PageCreateEmail />,
      },
      {
        path: "/disparos-de-report/novo/:id",
        element: <PageSelectContent />,
      },
      {
        path: "/disparos-de-report/editar/:id/:step?",
        element: <PageEditEmail />,
      },
      {
        path: "/disparos-de-report/:id",
        element: <PageReportDetail />,
      },
      {
        path: "/disparos-de-agenda/novo/:id",
        element: <PageCreateAgenda />,
      },
      {
        path: "/disparos-de-agenda/editar/:id",
        element: <PageEditAgendaIdentify />,
      },
      {
        path: "/disparos-de-agenda/editar/:id/notas",
        element: <PageCreateAgendaTopics />,
      },
      {
        path: "/disparos-de-agenda/editar/:id/conferir-dados",
        element: <PageCreateAgendaCheckData />,
      },

      {
        path: "/disparos-de-agenda/:id",
        element: <PageAgendaDetail />,
        children: [
          {
            path: "logs/:logId",
            element: <ViewLog />,
          },
        ],
      },
      {
        path: "/disparos-de-newsletter/:id",
        element: <PageNewsletterDetail />,
      },
      {
        path: "/disparos-de-newsletter/:id/revisar",
        element: (
          <ProtectedRoute allowedRoles={["admin", "partner"]}>
            <PageNewsletterReview />
          </ProtectedRoute>
        ),
      },
      {
        path: "/notas-de-agenda/nova/:contentGroupId",
        element: <PageCreateNote />,
      },
      {
        path: "/notas-de-agenda/nova/:id/topicos",
        element: <PageCreateNoteTopics />,
      },
      {
        path: "/notas-de-agenda/editar/:id",
        element: <PageEditNote />,
      },
      {
        path: "/notas-de-agenda/editar/:id/topics",
        element: <PageEditNote />,
      },
      {
        path: "/clientes/:id/perfil/:tab?",
        element: <PageEditCompany />,
      },
      {
        path: "/clientes/:id/membros",
        element: <PageCompanyMembers />,
      },
      {
        path: "/clientes/:companyId/membros/:id/editar",
        element: <PageEditCompanyRecipient />,
      },
      {
        path: "/usuarios/novo",
        element: <PageCreateUser />,
      },
      {
        path: "/usuarios/:id",
        element: <PageEditUser />,
      },
      {
        path: "/temas/novo",
        element: <PageCreateTheme />,
      },
      {
        path: "/temas/:id",
        element: <PageEditTheme />,
      },
      {
        path: "/parlamentares/novo",
        element: <PageCreatePerson />,
      },
      {
        path: "/parlamentares/:id",
        element: <PageEditPerson />,
      },
      {
        path: "/pls/novo",
        element: <PageCreatePL />,
      },
      {
        path: "/pls/:id",
        element: <PageEditPL />,
      },
      {
        path: "/tags/:type/novo",
        element: <PageCreateTag />,
      },
      {
        path: "/tags/:type/:id",
        element: <PageEditTag />,
      },
      {
        path: "/modelos-de-disparo/novo/:type",
        element: <PageCreateContentGroup />,
      },
      {
        path: "/modelos-de-disparo/:id",
        children: [
          {
            path: 'categorias',
            element: <PageEditContentGroup defaultTabIndex={1} />,
          },
          {
            path: '',
            element: <PageEditContentGroup />,
          },
        ],
      },
      {
        path: "/",
        element: <LayoutMain />,
        children: [
          {
            path: "/analytics",
            element: <PageAnalytics />,
          },
          {
            path: "/biblioteca-de-midia",
            element: <PageMediaLibrary />,
          },
          {
            path: "/listas-de-disparo",
            element: <PageLists />,
          },
          {
            path: "/modelos-de-disparo",
            element: <PageContentGroups />,
          },
          {
            path: "/relatorios",
            element: <PageReports />,
          },
          {
            path: "/disparos-de-report",
            element: <PageEmails />,
          },
          {
            path: "/notas-de-agenda",
            element: <PageNotes />,
          },
          {
            path: "/disparos-de-agenda",
            element: <PageAgendaList />,
          },
          {
            path: "/disparos-de-newsletter",
            element: <PageNewsletters />,
          },
          {
            path: "/disparos-de-newsletter/aguardando-revisao",
            element: (
              <ProtectedRoute allowedRoles={["admin", "partner"]}>
                <PageNewslettersForReview />
              </ProtectedRoute>
            ),
          },
          {
            path: "/clientes",
            element: <PageCompanies />,
          },
          {
            path: "/usuarios",
            element: <PageUsers />,
          },
          {
            path: "/temas",
            element: <PageThemes />,
          },
          {
            path: "/parlamentares",
            element: <PagePeople />,
          },
          {
            path: "/pls",
            element: <PagePLs />,
          },
          {
            path: "/tags/:type",
            element: <PageTags />,
          },
        ],
      },
    ],
  },
]);

export default router;
